import { useFormikContext } from "formik";
import { CheckboxField, InputField } from "melco-shared-logic";
import { Col, DesignTokens, FormItem, Row } from "melco-ui";
import { PressureFootSelect } from "../select/PressureFootSelect";
import { useEffect, useState } from "react";
import { HoopVersionSelect } from "../select/HoopVersionSelect";
import { HoopTypeSelect } from "../select/HoopTypeSelect";
import { HoopPublishedSupplierSelect } from "../select/HoopPublishedSupplierSelect";
import { HoopSupplierProductSelect } from "../select/HoopSupplierProductSelect";
import { useGetSupplierProductsBySupplierId } from "../../../hooks/supplierproducts/useGetSupplierProductsBySupplierId";
import { useTranslation } from "react-i18next";

type BasicHoopTabProps = {

}

export const BasicHoopTab: React.FC<BasicHoopTabProps> = () => {

    const { setFieldValue, values, status } = useFormikContext();
    const [formFields, setFormFields] = useState<any>(values);
    const [supplierId,] = useState(formFields.supplier_id)
    const [supplierProductData,] = useState<any>();

    useGetSupplierProductsBySupplierId(supplierId);

    const { t } = useTranslation();
    const { spacings } = DesignTokens

    useEffect(() => {
        setFormFields(values);

    }, [values])

    return (
        <>
            <Row gutter={[spacings.middle, spacings.small]} >
                <Col xs={24} md={12} xl={12}>
                    <InputField name="id" placeholder={t('managehoops.tabs.basic.id')} label={t('managehoops.tabs.basic.id')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="backward_compatibility_id" type="string" label={t('managehoops.tabs.basic.backward_compatibility_id')} placeholder={t('managehoops.tabs.basic.backward_compatibility_id')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="name" placeholder={t('managehoops.tabs.basic.name')} label={t('managehoops.tabs.basic.name')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="melco_pn" placeholder={t('managehoops.tabs.basic.melco_pn')} label={t('managehoops.tabs.basic.melco_pn')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="english_dimensions" placeholder={t('managehoops.tabs.basic.english_dimensions')} label={t('managehoops.tabs.basic.english_dimensions')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="metric_dimensions" placeholder={t('managehoops.tabs.basic.metric_dimensions')} label={t('managehoops.tabs.basic.metric_dimensions')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="width_points" type="number" placeholder={t('managehoops.tabs.basic.width_points')} label={t('managehoops.tabs.basic.width_points')} />
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <InputField name="height_points" type="number" placeholder={t('managehoops.tabs.basic.height_points')} label={t('managehoops.tabs.basic.height_points')} />
                </Col>


                <Col xs={24} md={12} xl={12}>
                    <FormItem label={t('managehoops.tabs.basic.supplier')}>
                        <HoopPublishedSupplierSelect
                            value={formFields.supplier_id}

                            onChange={((value: string) => {

                                setFieldValue("supplier_id", value);
                                setFieldValue("supplier_product_id", undefined)
                                // Refresh Page to reload Supplier Produuct based upon Supplier ID
                                //setSupplierId()
                                // setSupplierId(value);
                            })
                            } />
                    </FormItem>
                </Col>
                {/* <Col xs={24} md={12} xl={12} >
                    <FormItem>  <Checkbox
                        name="enable_templates"
                        onChange={(e: CheckboxChangeEvent) => {
                            let value = e.target.checked;
                            debugger
                            setFieldValue("enable_templates", value)
                        }}
                        defaultChecked={hoop.enable_templates}
                    >
                        Enable Templates
                    </Checkbox>
                    </FormItem>
                </Col> */}
                <Col xs={24} md={12} xl={12}>
                    <FormItem label={t('managehoops.tabs.basic.supplier_product')}>
                        {<HoopSupplierProductSelect
                            supplier_id={formFields.supplier_id}
                            data={supplierProductData}
                            value={formFields.supplier_product_id}
                            onChange={((value: string) => {

                                setFieldValue("supplier_product_id", value)
                            })
                            }
                        />
                        }
                    </FormItem>
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <FormItem label={t('managehoops.tabs.basic.version')}>
                        <HoopVersionSelect
                            // onChange={(value: any) => {
                            //       
                            //     setFieldValue("version", value);
                            // }}
                            // value={formFields?.version !== 0 ? formFields.version : setFieldValue("version", undefined)}
                            value={formFields?.version ?? undefined}
                        />
                    </FormItem>
                </Col>
                <Col xs={24} md={12} xl={12}>

                    <FormItem label={t('managehoops.tabs.basic.presser_foot')}>
                        <PressureFootSelect
                            //mode="multiple"
                            onchange={(value: string[]) => {

                                setFieldValue("presser_foot", value.toString())
                            }

                            }
                            value={
                                formFields?.presser_foot && formFields.presser_foot !== ""
                                    ? formFields?.presser_foot.split(',') : []
                            }
                        // value={["26", "44C"]}
                        />
                    </FormItem>
                </Col>
                <Col xs={24} md={24} xl={24}>
                    <FormItem label={t('managehoops.tabs.basic.type')}>
                        <HoopTypeSelect
                            onChange={(value: string) => {

                                setFieldValue("type", value)
                            }}
                            value={formFields.type} />
                    </FormItem>

                </Col>
                <Col xs={24} md={12} xl={12}>
                    <FormItem>
                        <CheckboxField
                            name="enable_templates"
                            defaultChecked={formFields.enable_templates}
                        // onChange={(e: CheckboxChangeEvent) => {
                        //     setFieldValue("enable_templates", e.target.checked)
                        // }}
                        >
                            {t('managehoops.tabs.basic.enable_templates')}
                        </CheckboxField>
                    </FormItem>
                </Col>
                <Col xs={24} md={12} xl={12}>
                    <FormItem>
                        <CheckboxField
                            name="discontinued"
                            defaultChecked={formFields.discontinued}
                        //     onChange={(e: CheckboxChangeEvent) => {
                        //         setFieldValue("discontinued", e.target.checked)
                        //     }
                        // }
                        >
                            {t('managehoops.tabs.basic.discontinued')}
                        </CheckboxField>
                    </FormItem>
                </Col>


            </Row>
        </>)
}